import type { StatusColor } from '@uiKit/components/StatusBadge.vue'
import { WITHDRAW_REQUEST_STATUS, type WithdrawRequestStatus } from '../types/withdrawRequestsTypes'

const STATUS_COLOR: Record<WithdrawRequestStatus, StatusColor> = {
  [WITHDRAW_REQUEST_STATUS.PENDING_APPROVAL]: 'warning',
  [WITHDRAW_REQUEST_STATUS.APPROVED]: 'info',
  [WITHDRAW_REQUEST_STATUS.AWAITING_SETTLEMENT]: 'info',
  [WITHDRAW_REQUEST_STATUS.COMPLETED]: 'success',
  [WITHDRAW_REQUEST_STATUS.REJECTED]: 'danger',
  [WITHDRAW_REQUEST_STATUS.FAILED]: 'danger',
  [WITHDRAW_REQUEST_STATUS.CANCELED]: 'neutral',
}

const STATUS_LABEL: Record<WithdrawRequestStatus, string> = {
  [WITHDRAW_REQUEST_STATUS.PENDING_APPROVAL]: 'Pending approval',
  [WITHDRAW_REQUEST_STATUS.APPROVED]: 'Approved',
  [WITHDRAW_REQUEST_STATUS.AWAITING_SETTLEMENT]: 'Awaiting settlement',
  [WITHDRAW_REQUEST_STATUS.COMPLETED]: 'Completed',
  [WITHDRAW_REQUEST_STATUS.REJECTED]: 'Rejected',
  [WITHDRAW_REQUEST_STATUS.FAILED]: 'Failed',
  [WITHDRAW_REQUEST_STATUS.CANCELED]: 'Canceled',
}

export function getWithdrawStatusColor(status: WithdrawRequestStatus): StatusColor {
  return STATUS_COLOR[status] ?? 'neutral'
}

export function getWithdrawStatusLabel(status: WithdrawRequestStatus): string {
  return STATUS_LABEL[status] ?? status
}

/**
 * Short middle-truncated UUID for the operator's eye — keeps prefix and
 * suffix, replaces the middle. Used for ids displayed inline in the
 * drawer header / detail.
 */
export function shortenId(id: string, head = 8, tail = 4): string {
  if (!id) return ''
  if (id.length <= head + tail + 1) return id
  return `${id.slice(0, head)}…${id.slice(-tail)}`
}
